export enum SidebarState {
  COLLAPSED = 'COLLAPSED',
  EXPANDED = 'EXPANDED',
}
